var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-item viewable",
      class: {
        image: _vm.isImage,
        "show-usage": _vm.showTag,
        editable: _vm.editable,
        deletable: _vm.deletable && !_vm.uploading,
        downloadable: _vm.downloadable,
        "show-md5": _vm.showMd5,
        "show-file-change": _vm.showMd5
      }
    },
    [
      !_vm.isViewVideo
        ? _c("div", { staticClass: "file-name ellipsis-1" }, [
            _vm._v(_vm._s(_vm.$fileName))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isImage ? _c("img", { attrs: { src: _vm.$imageUrl } }) : _vm._e(),
      _vm._v(" "),
      _vm.isViewVideo
        ? _c("video", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { src: _vm.$fileBrowseUrl }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "usage ellipsis-1" }, [_vm._v(_vm._s(_vm.tag))]),
      _vm._v(" "),
      _c("div", { staticClass: "edit-mask" }),
      _vm._v(" "),
      _c("div", { staticClass: "operation-group" }, [
        _vm.isImage
          ? _c("i", {
              staticClass: "icon iconfont icon-chakan view",
              on: { click: _vm.viewAsImg }
            })
          : _vm.isViewableDoc
          ? _c("i", {
              staticClass: "icon iconfont icon-chakan view",
              on: { click: _vm.viewAsDoc }
            })
          : _vm.isViewVideo
          ? _c("i", {
              staticClass: "icon iconfont icon-chakan view",
              on: { click: _vm.viewAsVideo }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.downloadable && !_vm.isImage
          ? _c("i", {
              staticClass: "icon iconfont icon-xiazai download",
              on: { click: _vm.$download }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.editable
          ? _c("span", { staticClass: "icon iconfont icon-bianji edit" })
          : _vm._e(),
        _vm._v(" "),
        _vm.showMd5
          ? _c("i", { staticClass: "md5", on: { click: _vm.$openMd5Page } })
          : _vm._e(),
        _vm._v(" "),
        _vm.showMd5
          ? _c("i", {
              staticClass:
                "icon iconfont icon-xiugaijilu2 file-change font-blue",
              on: { click: _vm.$showRepoFileBizRec }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "delete-icon" }),
      _vm._v(" "),
      _vm.uploading
        ? _c("div", { staticClass: "progress" }, [
            _c("img", {
              directives: [
                {
                  name: "resc-url",
                  rawName: "v-resc-url",
                  value: "/image/loading.gif",
                  expression: "'/image/loading.gif'"
                }
              ]
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.uploadingProgress) + "%")])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50c7726e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c7726e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/FileItem.vue
// module id = 2484
// module chunks = 0